import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from '../ProjectsList.module.scss';

const DeleteLabel = ({ name }) => {
  const { t } = useTranslation('projects');

  return (
    <span>
      {t('doYouReallyWantToDelete')}: <span className={scss.stressedName}>{name}</span>?
    </span>
  );
};

export default DeleteLabel;
